/**
 *  @class
 *  @function SlideShow
 */
if (!customElements.get('slide-show')) {
  class SlideShow extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      requestAnimationFrame(() => this.init());
    }
    init() {
      if (this._flkty) return;
     
      const slideshow = this;
      const dataset = slideshow.dataset;
      let
        parent_section = slideshow.closest('.shopify-section'),
        slideshow_slides = Array.from(slideshow.querySelectorAll('.carousel__slide')),
        autoplay = dataset.autoplay == 'false' ? false : parseInt(dataset.autoplay, 10),
        align = dataset.align == 'center' ? 'center' : 'left',
        fade = dataset.fade == 'true',
        pageDots = dataset.dots == 'true',
        prev_button = slideshow.querySelector('.flickity-prev'),
        next_button = slideshow.querySelector('.flickity-next'),
        header = document.querySelector('theme-header'),
        custom_dots = slideshow.querySelector('.flickity-custom-dots'),
        custom_navigation = slideshow.querySelector('.flickity-custom-navigation'),
        autoplay_progress = slideshow.querySelector('.slideshow--autoplay-progress'),
        progress_bar = slideshow.parentNode.querySelector('.flickity-progress--bar'),
        animations = [],
        rightToLeft = document.dir === 'rtl',
        cell_align = (align == 'left' && rightToLeft ? 'right' : 'left'),
        animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined',
        selectedIndex = 0,
        args = {
          wrapAround: true,
          cellAlign: cell_align,
          pageDots: pageDots,
          contain: true,
          fade: fade,
          autoPlay: autoplay,
          rightToLeft: rightToLeft,
          prevNextButtons: false,
          cellSelector: '.carousel__slide',
          on: {}
        };

      // Early return guard
      if (slideshow_slides.length < 1) return;

      // Cache classList checks
      const isImageTextContent = slideshow.classList.contains('image-with-text-slideshow--content');
      const isImageTextImage = slideshow.classList.contains('image-with-text-slideshow--image');
      const isCustomerReviewsContent = slideshow.classList.contains('customer-reviews--content');
      const isCustomerReviewsImage = slideshow.classList.contains('customer-reviews--image');
      const isCustomerReviewsCarousel = slideshow.classList.contains('customer-reviews--carousel');
      const isCustomDots = !!custom_dots;
      const isMainSlideshow = slideshow.classList.contains('main-slideshow');
      const isProducts = slideshow.classList.contains('products');
      const isCollectionGrid = slideshow.classList.contains('collection-grid__carousel');
      const isMediaWithTabs = slideshow.classList.contains('media-with-tabs--media');
      const isAnnouncementBarColors = slideshow.classList.contains('announcement-bar--use-colors-true');
      // Cache custom dot elements once
      const cached_dot_list = isCustomDots ? Array.from(custom_dots.querySelectorAll('li')) : null;

      // Store instance refs for cleanup
      this._animations = animations;
      this._animations_enabled = animations_enabled;

      this.paused = false;
      if (isCustomDots) {
        args.pageDots = false;
      }
      if (isImageTextContent) {
        let main_slideshow = slideshow.parentNode.querySelector('.image-with-text-slideshow--image');
        args.draggable = false;
        args.asNavFor = main_slideshow;
      }
      if (isImageTextImage) {
        let image_slideshow_slides = slideshow.querySelectorAll('.image-with-text-slideshow--image-media');

        if (image_slideshow_slides.length) {
          if (image_slideshow_slides[0].classList.contains('desktop-height-auto')) {
            args.adaptiveHeight = true;
          }
        }
      }
      if (isImageTextContent ||
        isCustomerReviewsContent ||
        isCustomerReviewsImage) {
        args.adaptiveHeight = true;
      }
      if (isCustomerReviewsCarousel) {
        args.wrapAround = false;
        args.adaptiveHeight = false;
        args.resize = true;
        args.on.ready = function () {
          let flkty = this;
          flkty.resize();
          document.fonts.ready.then(() => requestAnimationFrame(() => flkty.resize()));
        };
      }
      if (isCollectionGrid) {
        args.wrapAround = false;
      }
      // Main Slideshow
      if (isMainSlideshow) {

        if (animations_enabled) {
          slideshow.prepareAnimations(slideshow, animations);
        }

        args.on = {
          staticClick: function () {
            this.unpausePlayer();
          },
          ready: function () {
            let flkty = this;

            // Transparent Header padding.
            if (header) {
              if (header.classList.contains('transparent--true')) {
                let sections = Array.from(document.querySelector('#main-content').querySelectorAll(':scope > .shopify-section')),
                  i = sections.indexOf(parent_section);

                if (i == 0 && slideshow.classList.contains('section-spacing--disable-top')) {
                  slideshow.classList.add('slideshow--top');
                }
              }
            }
            // Animations.
            if (animations_enabled) {
              slideshow.animateSlides(0, slideshow, animations);
            }

            // AutoPlay Progress
            if (autoplay && autoplay_progress && animations_enabled) {
              slideshow.setupAutoplayProgress(slideshow);
            }

            // Fonts resize
            document.fonts.ready.then(() => requestAnimationFrame(() => flkty.resize()));

            // Video Support.
            let video_container = flkty.cells[0].element.querySelector('.slideshow__slide-video-bg');
            if (video_container) {

              if (video_container.querySelector('iframe')) {
                video_container.querySelector('iframe').onload = function () {
                  slideshow.videoPlay(video_container);
                };
              } else if (video_container.querySelector('video')) {
                video_container.querySelector('video').onloadstart = function () {
                  slideshow.videoPlay(video_container);
                };
              }
            }
          },
          change: function (index) {
            let flkty = this,
              previousIndex = fizzyUIUtils.modulo(flkty.selectedIndex - 1, flkty.slides.length);

            // Animations.
            if (animations_enabled) {
              slideshow.animateReverse(previousIndex, slideshow, animations);
              slideshow.animateSlides(index, slideshow, animations);
            }

            // Color changes.
            requestAnimationFrame(() => {
              let color_text = getComputedStyle(flkty.selectedElement).getPropertyValue('--color-text');
              if (autoplay_progress && animations_enabled) {
                autoplay_progress.style.setProperty('--color-body', color_text);
              }
              let page_dots = slideshow.querySelector('.flickity-page-dots');
              if (page_dots) {
                page_dots.style.setProperty('--color-body', color_text);
              }
            });

            // Custom Dots.
            if (custom_navigation) {
              custom_navigation.querySelector('.flickity-custom-navigation--current').innerHTML = this.selectedIndex + 1;
            }

            // AutoPlay Progress
            if (autoplay) {

              if (flkty.player.state !== 'paused') {
                flkty.stopPlayer();
                flkty.playPlayer();
              }
            }
            if (autoplay && autoplay_progress && animations_enabled) {
              slideshow._autoPlayProgressTL.progress(0);

              if (flkty.player.state !== 'paused') {
                slideshow._autoPlayProgressTL.play();
              }
            }

            // Video Support.
            // previous slide
            let video_container_prev = flkty.cells[previousIndex].element.querySelector('.slideshow__slide-video-bg');
            if (video_container_prev) {
              slideshow.videoPause(video_container_prev);
            }
            // current slide
            let video_container = flkty.cells[index].element.querySelector('.slideshow__slide-video-bg');
            if (video_container) {
              if (video_container.querySelector('iframe')) {
                if (video_container.querySelector('iframe').classList.contains('lazyload')) {
                  video_container.querySelector('iframe').addEventListener('lazybeforeunveil', () => slideshow.videoPlay(video_container));
                  lazySizes.loader.checkElems();
                } else {
                  slideshow.videoPlay(video_container);
                }
              } else if (video_container.querySelector('video')) {
                slideshow.videoPlay(video_container);
              }
            }

          }
        };
        if (slideshow.classList.contains('desktop-height-image') || slideshow.classList.contains('mobile-height-image')) {
          args.adaptiveHeight = true;
        }
      }

      // Media with tabs
      if (isMediaWithTabs) {
        args.draggable = false;
        args.on = {
          staticClick: function () {
            this.unpausePlayer();
          },
          ready: function () {
            let flkty = this;

            // Video Support.
            let video_container = flkty.cells[0].element.querySelector('.media-with-tabs--media--video');
            if (video_container) {
              video_container.querySelector('video').onloadstart = function () {
                slideshow.videoPlay(video_container);
              };
            }
          },
          change: function (index) {
            let flkty = this,
              previousIndex = fizzyUIUtils.modulo(flkty.selectedIndex - 1, flkty.slides.length);

            // Video Support.
            // previous slide
            let video_container_prev = flkty.cells[previousIndex].element.querySelector('.media-with-tabs--media--video');
            if (video_container_prev) {
              slideshow.videoPause(video_container_prev);
            }
            // current slide
            let video_container = flkty.cells[index].element.querySelector('.media-with-tabs--media--video');
            if (video_container) {
              slideshow.videoPlay(video_container);
            }
          }
        };
      }

      // Announcement bar color change
      if (isAnnouncementBarColors) {
        args.on.change = function (index) {
          const container = slideshow.closest('.announcement-bar');
          let color_text = this.selectedElement.dataset.color,
            color_bg = this.selectedElement.dataset.bg;

          container.style.setProperty('--color-announcement-bar-bg', color_bg);
          container.style.setProperty('--color-announcement-bar-text', color_text);
        };
      }

      // Product Carousels
      if (isProducts) {
        let _resizeRAF;
        args.wrapAround = false;
        args.on.ready = function () {
          var flickity = this;
          if (next_button) {
            slideshow._resizeHandler = function () {
              cancelAnimationFrame(_resizeRAF);
              _resizeRAF = requestAnimationFrame(() => {
                slideshow.centerArrows(flickity, slideshow, prev_button, next_button);
              });
            };
            window.addEventListener('resize.center_arrows', slideshow._resizeHandler);
          }
          window.dispatchEvent(new Event('resize.center_arrows'));
        };
      }
      if (progress_bar) {
        args.wrapAround = false;
        args.on.scroll = function (progress) {
          cancelAnimationFrame(slideshow._scrollRAF);
          slideshow._scrollRAF = requestAnimationFrame(() => {
            progress = Math.max(0, Math.min(1, progress));
            progress_bar.style.width = progress * 100 + '%';

            if (prev_button) {
              let atStart = rightToLeft ? progress === 1 : progress === 0,
                atEnd = rightToLeft ? progress === 0 : progress === 1;
              prev_button.classList.toggle('hide-arrow', atStart);
              next_button.classList.toggle('hide-arrow', atEnd);
              if (atStart) {
                prev_button.setAttribute('disabled', true);
              } else if (atEnd) {
                next_button.setAttribute('disabled', true);
              } else {
                next_button.removeAttribute('disabled');
                prev_button.removeAttribute('disabled');
              }
            }
          });
        };
      }

      // Testimonials
      if (isCustomDots) {
        args.on = {
          ready: function () {
            let flkty = this;

            // Custom Dots.
            cached_dot_list.forEach((dot, i) => {
              dot.addEventListener('click', () => {
                flkty.select(i);
              });
            });
            cached_dot_list[this.selectedIndex].classList.add('is-selected');
          },
          change: function () {

            // Custom Dots.
            cached_dot_list.forEach((dot) => {
              dot.classList.remove('is-selected');
            });
            cached_dot_list[this.selectedIndex].classList.add('is-selected');
          }
        };
      }

      // Customer reviews
      if (isCustomerReviewsCarousel) {
        let _resizeRAF;
        args.on.ready = function () {
          var flickity = this;
          if (next_button) {
            slideshow._resizeHandler = function () {
              cancelAnimationFrame(_resizeRAF);
              _resizeRAF = requestAnimationFrame(() => {
                slideshow.centerArrows(flickity, slideshow, prev_button, next_button);
              });
            };
            window.addEventListener('resize.center_arrows', slideshow._resizeHandler);
          }
          window.dispatchEvent(new Event('resize.center_arrows'));
        };
      }

      // Initiate
      const flkty = new Flickity(slideshow, args);

      selectedIndex = flkty.selectedIndex;

      dataset.initiated = true;

      // Store Flickity instance for cleanup
      this._flkty = flkty;

      // Arrows
      if (prev_button) {
        prev_button.addEventListener('click', () => {
          flkty.previous();
        });
        prev_button.addEventListener('keyup', () => {
          flkty.previous();
        });
        next_button.addEventListener('click', () => {
          flkty.next();
        });
        next_button.addEventListener('keyup', () => {
          flkty.next();
        });

        // Hide arrows at scroll ends for non-wrapping carousels
        if (!args.wrapAround) {
          prev_button.classList.add('hide-arrow');

          if (!progress_bar) {
            flkty.on('scroll', function (progress) {
              cancelAnimationFrame(slideshow._arrowRAF);
              slideshow._arrowRAF = requestAnimationFrame(() => {
                progress = Math.max(0, Math.min(1, progress));
                let atStart = rightToLeft ? progress === 1 : progress === 0,
                  atEnd = rightToLeft ? progress === 0 : progress === 1;
                prev_button.classList.toggle('hide-arrow', atStart);
                next_button.classList.toggle('hide-arrow', atEnd);
              });
            });
          }
        }
      }

      // Theme editor
      if (Shopify.designMode) {
        slideshow.addEventListener('shopify:block:select', (event) => {
          let index = slideshow_slides.indexOf(event.target);
          flkty.select(index);
        });
      }

    }
    disconnectedCallback() {
      // Destroy Flickity instance
      if (this._flkty) {
        this._flkty.destroy();
        this._flkty = null;
      }
      // Kill GSAP animation timelines
      if (this._animations) {
        this._animations.forEach((tl) => {
          if (tl && tl.kill) tl.kill();
        });
        this._animations = null;
      }
      // Revert SplitText instances
      if (this._splitTexts) {
        this._splitTexts.forEach((st) => {
          if (st && st.revert) st.revert();
        });
        this._splitTexts = null;
      }
      // Kill autoplay progress timeline
      if (this._autoPlayProgressTL) {
        this._autoPlayProgressTL.kill();
        this._autoPlayProgressTL = null;
      }
      // Remove window resize listener
      if (this._resizeHandler) {
        window.removeEventListener('resize.center_arrows', this._resizeHandler);
        this._resizeHandler = null;
      }
      // Cancel pending scroll rAF
      if (this._scrollRAF) {
        cancelAnimationFrame(this._scrollRAF);
        this._scrollRAF = null;
      }
      // Reset dataset flags
      this.dataset.initiated = '';
      this.dataset.animationsReady = '';
    }
    setupAutoplayProgress(slideshow) {
      slideshow._autoPlayProgressTL = gsap.timeline({
        inherit: false
      });
      slideshow._autoPlayProgressTL
        .fromTo(slideshow.querySelector('.thb-slideshow-progress--svg circle'), {
          drawSVG: 0
        }, {
          duration: parseInt(slideshow.dataset.autoplay, 10) / 1000,
          ease: 'none',
          drawSVG: true
        });
      slideshow.addEventListener('mouseenter', function () {
        slideshow._autoPlayProgressTL.pause().progress(0);
      });
      slideshow.addEventListener('mouseleave', function () {
        slideshow._autoPlayProgressTL.play();
      });
    }

    videoPause(video_container) {
      setTimeout(() => {
        let video = video_container.querySelector('video');
        if (video) video.pause();
      }, 10);
    }
    videoPlay(video_container) {
      setTimeout(() => {
        let video = video_container.querySelector('video');
        if (video) video.play();
      }, 10);
    }
    prepareAnimations(slideshow, animations) {
      if (!slideshow.dataset.animationsReady) {
        let text_els = slideshow.querySelectorAll('.slideshow__slide-heading, p:not(.subheading)');
        let splittext = new SplitText(text_els, {
          type: 'lines',
          linesClass: 'line-child'
        });
        let mask = new SplitText(text_els, {
          type: 'lines',
          linesClass: 'line-parent'
        });
        slideshow._splitTexts = [splittext, mask];

        let isZoom = slideshow.dataset.transition == 'zoom';

        slideshow.querySelectorAll('.slideshow__slide').forEach((item, i) => {
          let tl = gsap.timeline({
            paused: true
          }),
            button_offset = 0;

          animations[i] = tl;

          if (isZoom) {
            tl
              .to(item.querySelectorAll('.slideshow__slide-bg, .slideshow__slide-video-bg'), {
                duration: 1.5,
                scale: 1
              }, "start");
          }

          let inline_badge = item.querySelector('.inline-badge');
          if (inline_badge) {
            tl
              .fromTo(inline_badge, {
                opacity: 0
              }, {
                duration: 0.5,
                opacity: 1
              }, 0);

            button_offset += 0.2;
          }
          let subheading = item.querySelector('.subheading');
          if (subheading) {
            tl
              .fromTo(subheading, {
                opacity: 0
              }, {
                duration: 0.5,
                opacity: 1
              }, 0);

            button_offset += 0.5;
          }
          let heading = item.querySelector('.slideshow__slide-heading');
          if (heading) {
            let heading_lines = item.querySelectorAll('.slideshow__slide-heading .line-child');
            let h1_duration = 1 + ((heading_lines.length - 1) * 0.1);
            tl
              .set(heading, {
                opacity: 1
              }, 0)
              .from(heading_lines, {
                duration: h1_duration,
                yPercent: 120,
                stagger: 0.1,
                rotation: '3deg'
              }, 0);
            button_offset += h1_duration;
          }
          let split_text = item.querySelector('p.split-text');
          if (split_text) {
            let split_lines = item.querySelectorAll('p.split-text .line-child');
            let p_duration = 1 + ((split_lines.length - 1) * 0.05);
            tl
              .set(split_text, {
                opacity: 1
              }, 0)
              .from(item.querySelectorAll('p:not(.subheading) .line-child'), {
                duration: p_duration,
                yPercent: '120',
                stagger: 0.1,
                rotation: '3deg'
              }, 0);
            button_offset += p_duration;
          }
          let buttons = item.querySelectorAll('.button, .text-button');
          if (buttons.length) {
            tl
              .fromTo(buttons, {
                y: '100%'
              }, {
                duration: 0.5,
                y: '0%',
                stagger: 0.1,
              }, button_offset * 0.2);
          }
          item.dataset.timeline = tl;
        });

        slideshow.dataset.animationsReady = true;
      }
    }
    animateSlides(i, slideshow, animations) {
      document.fonts.ready.then(function () {
        animations[i].timeScale(1).restart();
      });
    }
    animateReverse(i, slideshow, animations) {
      animations[i].timeScale(3).reverse();
    }
    centerArrows(flickity, slideshow, prev_button, next_button) {
      let first_el = flickity.cells[0].element,
        max_height = 0,
        image_height = 0;

      let featured_image = first_el.querySelector('.product-featured-image');
      if (featured_image) {
        image_height = featured_image.clientHeight;
      } else if (first_el.querySelector('.gallery--item')) {
        image_height = flickity.cells[1].element.querySelector('.product-featured-image').clientHeight;
      }

      let reviews_product = first_el.querySelector('.customer-reviews--product');
      if (slideshow.classList.contains('customer-reviews--carousel') && reviews_product) {
        image_height = flickity.cells[1].element.querySelector('.customer-reviews--product').clientHeight;
      }

      if (image_height > 0) {
        for (let i = 0; i < flickity.cells.length; i++) {
          if (flickity.cells[i].size.height > max_height) {
            max_height = flickity.cells[i].size.height;
          }
        }

        if (max_height > image_height) {
          let offset = 'translateY(' + ((max_height - image_height) / -2) + 'px)';
          prev_button.style.transform = offset;
          next_button.style.transform = offset;
        }
      }
    }
  }
  customElements.define('slide-show', SlideShow);
}
